import { ImageElement } from '@kontent-ai/gatsby-components';
import tw from 'twin.macro';

export const StyledImage = tw(ImageElement)`pr-4`;
